/**
 * Created by razial on 04.03.2025.
 */

const UnitsLibraryHelper = {
    Switch: function (locationId) {
        cleverapps.unitsLibrary = this.GetInstance(locationId);
    },

    ResolveUnit: function (unit) {
        if (unit.type === "resource") {
            return {
                code: UnitsLibraryHelper.GetInstance("main").getCurrentCastleResource(),
                stage: unit.stage,
                amount: unit.amount
            };
        }

        if (unit.type === "reschest") {
            return {
                code: `${UnitsLibraryHelper.GetInstance("main").getCurrentCastleResource()}chest`,
                stage: unit.stage,
                amount: unit.amount
            };
        }

        if (unit.type === "fruit") {
            return {
                code: UnitsLibraryHelper.GetInstance("main").getCurrentFruit(),
                stage: unit.stage,
                amount: unit.amount
            };
        }

        return unit;
    },

    ResolveRewardUnits: function (reward) {
        if (!reward || !reward.units) {
            return reward;
        }

        reward = { ...reward };
        reward.units = Array.isArray(reward.units) ? reward.units.map(UnitsLibraryHelper.ResolveUnit) : UnitsLibraryHelper.ResolveUnit(reward.units);
        return reward;
    },

    Reset: function () {
        cleverapps.unitsLibrary = undefined;
    },

    GetInstance: function (locationId) {
        if (this.usesMainInstance(locationId)) {
            locationId = "main";
        }

        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        const locationConfig = locationMeta.locationConfig;

        return cleverapps.unitsLibrary && cleverapps.unitsLibrary.locationConfig === locationConfig
            ? cleverapps.unitsLibrary
            : new UnitsLibrary(locationConfig);
    },

    // for compatibility with old expeditions
    usesMainInstance: function (locationId) {
        if (["mergecraft", "wondermerge", "fairy"].indexOf(cleverapps.config.name) !== -1 && ["collections", "dragonia2", "dragonia3", "undersea2", "rapunzel2", "rapunzel3"].indexOf(locationId) !== -1) {
            return true;
        }
        if (["mergecraft"].indexOf(cleverapps.config.name) !== -1 && ["undersea3"].indexOf(locationId) !== -1) {
            return true;
        }

        return locationId === "main";
    },

    // for compatibility with old expeditions
    resetMainInstanceFamilies: function (locationId) {
        if (!this.usesMainInstance(locationId)) {
            return;
        }

        const activeFamilies = {};

        cleverapps.meta.listActiveLocations().forEach((activeLocationId) => {
            if (activeLocationId !== locationId && this.usesMainInstance(activeLocationId)) {
                Object.assign(activeFamilies, Families.listExpeditionCodes(activeLocationId));
            }
        });

        const families = Object.keys(Families.listExpeditionCodes(locationId)).filter((code) => !activeFamilies[code]);

        this.GetInstance("main").resetFamilies(families);
    }
};

SyncAdapters.unitsLibraryHelper = {
    beforeUpdate: () => {
        UnitsLibraryHelper.Reset();
    }
};

UniversalSlot.registerTable("unitslibrary", {
    getInfo: (slot) => slot.load("unitslibrary") || {},
    updateInfo: (slot, serverData) => slot.save("unitslibrary", serverData, true)
});
